import React, { Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router} from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext.js';  

// Components Imports
import AuthRoutes from './routes/AuthRoutes.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import MySpinner from './components/MySpinner.jsx';
import theme from './theme/theme.js';
  function App() {
     const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    const handler = () => setMaintenance(true);
    window.addEventListener('maintenance-mode', handler);
    return () => window.removeEventListener('maintenance-mode', handler);
  }, []);

   if (maintenance) {
    return (
      <div style={{
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        height: '100vh', fontFamily: 'sans-serif', direction: 'rtl'
      }}>
        <h1>  النظام تحت الصيانة</h1>
        <p>نعمل على تحسين النظام يرجى المحاولة لاحقاً</p>
      </div>
    );
  }

  return (
    <ErrorBoundary>
    <Suspense fallback={<MySpinner color={theme.colors.primary} className='spinner-overlay' />}>  
      <Router> 
        <AuthProvider> 
          <AuthRoutes />
        </AuthProvider>
      </Router>
    </Suspense>
    </ErrorBoundary>
  ); 
}


export default App;
